import "core-js/modules/es6.reflect.construct.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["collapsible", "header", "id", "footer", "expanded", "footerStyle", "headerStyle", "headerRole", "panelRole", "className", "colors", "children", "onEnter", "onEntering", "onEntered", "clsPrefix", "onExit", "headerContent", "onExiting", "onExited", "defaultExpanded", "eventKey", "onSelect", "copyable", "bordered", "ghost", "showArrow", "expandIconPosition"];

var _dec, _class;

import "core-js/modules/es6.array.fill.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import classnames from 'classnames';
import React, { cloneElement } from 'react';
import { Collapse } from '../../wui-transition/src';
import Message from '../../wui-message/src';
import PropTypes from 'prop-types';
import copy from 'copy-to-clipboard';
import { WebUI, prefix } from "../../wui-core/src/index.js";
import omit from "omit.js";
var propTypes = {
  //是否添加折叠
  collapsible: PropTypes.bool,
  onSelect: PropTypes.func,
  //头部组件
  header: PropTypes.node,
  headerStyle: PropTypes.object,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  headerContent: PropTypes.bool,
  //footer组件
  footer: PropTypes.node,
  footerStyle: PropTypes.object,
  //默认是否打开
  defaultExpanded: PropTypes.bool,
  //是否打开
  expanded: PropTypes.bool,
  //每个panel的标记
  eventKey: PropTypes.any,
  headerRole: PropTypes.string,
  panelRole: PropTypes.string,
  //颜色
  colors: PropTypes.oneOf(['primary', 'accent', 'success', 'info', 'warning', 'danger', 'default', 'bordered']),
  // From Collapse.的扩展动画
  onEnter: PropTypes.func,
  onEntering: PropTypes.func,
  onEntered: PropTypes.func,
  onExit: PropTypes.func,
  onExiting: PropTypes.func,
  onExited: PropTypes.func,
  //是否可复制内容
  copyable: PropTypes.bool
};
var defaultProps = {
  collapsible: true,
  defaultExpanded: false,
  clsPrefix: "u-collapse",
  colors: "default",
  bordered: false,
  ghost: false,
  showArrow: true,
  expandIconPosition: 'left',
  copyable: false,
  onEnter: function onEnter() {},
  onEntering: function onEntering() {},
  onEntered: function onEntered() {},
  onExit: function onExit() {},
  onExiting: function onExiting() {},
  onExited: function onExited() {},
  header: null,
  footer: null,
  headerStyle: {},
  footerStyle: {},
  eventKey: '',
  onSelect: null
};
var Panel = (_dec = WebUI({
  name: "collapse",
  defaultProps: defaultProps
}), _dec(_class = /*#__PURE__*/function (_React$Component) {
  _inherits(Panel, _React$Component);

  var _super = _createSuper(Panel);

  function Panel(props, context) {
    var _this;

    _classCallCheck(this, Panel);

    _this = _super.call(this, props, context);
    _this.handleClickTitle = _this.handleClickTitle.bind(_assertThisInitialized(_this));
    _this.state = {
      expanded: _this.props.defaultExpanded
    };
    return _this;
  } //头部点击事件


  _createClass(Panel, [{
    key: "handleClickTitle",
    value: function handleClickTitle(e) {
      // 不让事件进入事件池
      e.persist();
      e.selected = true;

      if (this.props.onSelect) {
        this.props.onSelect(this.props.eventKey, e);
      } else {
        e.preventDefault();
      }

      if (e.selected) {
        this.setState({
          expanded: !this.state.expanded
        });
      }
    } //渲染panelheader

  }, {
    key: "renderHeader",
    value: function renderHeader(collapsible, header, id, role, expanded, clsPrefix) {
      var titleClassName = "".concat(clsPrefix, "-title");

      if (!collapsible) {
        if (! /*#__PURE__*/React.isValidElement(header)) {
          return header;
        }

        return /*#__PURE__*/cloneElement(header, {
          className: classnames(header.props.className, titleClassName)
        });
      }

      if (! /*#__PURE__*/React.isValidElement(header)) {
        return /*#__PURE__*/React.createElement("h4", {
          role: "presentation",
          className: titleClassName
        }, this.renderAnchor(header, id, role, expanded));
      }

      if (this.props.headerContent) {
        return /*#__PURE__*/cloneElement(header, {
          className: classnames(header.props.className, titleClassName)
        });
      }

      return /*#__PURE__*/cloneElement(header, {
        className: classnames(header.props.className, titleClassName),
        children: this.renderAnchor(header.props.children, id, role, expanded)
      });
    } //如果使用链接，渲染为a标签

  }, {
    key: "renderAnchor",
    value: function renderAnchor(header, id, role, expanded) {
      return /*#__PURE__*/React.createElement("a", {
        role: role,
        href: id && "#".concat(id),
        "aria-controls": id,
        "aria-expanded": expanded,
        "aria-selected": expanded,
        className: expanded ? null : 'collapsed'
      }, header);
    } //复制代码，弹出提示信息

  }, {
    key: "copyDemo",
    value: function copyDemo(e) {
      var panelTarget = e.target.parentNode;
      var clipBoardContent = panelTarget.firstChild.innerText;
      copy(clipBoardContent);
      Message.create({
        content: '复制成功！',
        color: 'success',
        duration: 2
      });
    } //如果有折叠动画，渲染折叠动画

  }, {
    key: "renderCollapsibleBody",
    value: function renderCollapsibleBody(id, expanded, role, children, clsPrefix, copyable, animationHooks) {
      return /*#__PURE__*/React.createElement(Collapse, _extends({
        in: expanded
      }, animationHooks), /*#__PURE__*/React.createElement("div", {
        id: id,
        role: role,
        className: "".concat(clsPrefix, "-collapse"),
        "aria-hidden": !expanded
      }, this.renderBody(children, clsPrefix, copyable)));
    } //渲染panelbody

  }, {
    key: "renderBody",
    value: function renderBody(rawChildren, clsPrefix, copyable) {
      var self = this;
      var children = [];
      var bodyChildren = [];
      var bodyClassName = "".concat(clsPrefix, "-body"); //添加到body的children中

      function maybeAddBody(self) {
        if (!bodyChildren.length) {
          return;
        } // 给子组件添加key，为了之后触发事件时使用


        children.push( /*#__PURE__*/React.createElement("div", {
          key: children.length,
          className: bodyClassName
        }, bodyChildren, copyable && /*#__PURE__*/React.createElement("i", {
          className: "".concat(clsPrefix, "-copy uf uf-files-o"),
          onClick: self.copyDemo
        })));
        bodyChildren = [];
      } //转换为数组，方便复用


      React.Children.toArray(rawChildren).forEach(function (child) {
        if ( /*#__PURE__*/React.isValidElement(child) && child.props.fill) {
          maybeAddBody(self); //将标示fill设置为undefined

          children.push( /*#__PURE__*/cloneElement(child, {
            fill: undefined
          }));
          return;
        }

        bodyChildren.push(child);
      });
      maybeAddBody(self);
      return children;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          collapsible = _this$props.collapsible,
          header = _this$props.header,
          id = _this$props.id,
          footer = _this$props.footer,
          propsExpanded = _this$props.expanded,
          footerStyle = _this$props.footerStyle,
          headerStyle = _this$props.headerStyle,
          headerRole = _this$props.headerRole,
          panelRole = _this$props.panelRole,
          className = _this$props.className,
          colors = _this$props.colors,
          children = _this$props.children,
          onEnter = _this$props.onEnter,
          onEntering = _this$props.onEntering,
          onEntered = _this$props.onEntered,
          clsPrefix = _this$props.clsPrefix,
          onExit = _this$props.onExit,
          headerContent = _this$props.headerContent,
          onExiting = _this$props.onExiting,
          onExited = _this$props.onExited,
          defaultExpanded = _this$props.defaultExpanded,
          eventKey = _this$props.eventKey,
          onSelect = _this$props.onSelect,
          copyable = _this$props.copyable,
          bordered = _this$props.bordered,
          ghost = _this$props.ghost,
          showArrow = _this$props.showArrow,
          expandIconPosition = _this$props.expandIconPosition,
          props = _objectWithoutProperties(_this$props, _excluded);

      var expanded = propsExpanded != null ? propsExpanded : this.state.expanded;
      var classes = {};
      classes["".concat(clsPrefix)] = true;
      classes["".concat(clsPrefix, "-").concat(colors)] = true;

      if (bordered) {
        classes["".concat(clsPrefix, "-borderless")] = true;
      }

      if (ghost) {
        classes["".concat(clsPrefix, "-ghost")] = true;
      }

      if (showArrow) {
        classes["".concat(clsPrefix, "-arrow")] = true;
      }

      if (expandIconPosition === 'left') {
        classes["".concat(clsPrefix, "-icon-position-left")] = true;
      } else if (expandIconPosition === 'right') {
        classes["".concat(clsPrefix, "-icon-position-right")] = true;
      }

      var showClassName = expanded ? "".concat(prefix, "-panel-show") : "".concat(prefix, "-panel-hidden");
      classes["".concat(showClassName)] = true;

      var headerClass = _defineProperty({}, "".concat(clsPrefix, "-heading"), true);

      copyable === false ? false : true;
      var icon = expanded ? 'uf-arrow-down' : 'uf-arrow-right';
      return /*#__PURE__*/React.createElement("div", _extends({}, omit(props, ["defaultActiveKey"]), {
        className: classnames(className, classes),
        id: collapsible ? null : id
      }), header && /*#__PURE__*/React.createElement("div", {
        className: classnames(headerClass),
        style: headerStyle,
        onClick: this.handleClickTitle
      }, showArrow && /*#__PURE__*/React.createElement("i", {
        className: "uf ".concat(icon, " ").concat(clsPrefix, "-header-icon")
      }), this.renderHeader(collapsible, header, id, headerRole, expanded, clsPrefix)), collapsible ? this.renderCollapsibleBody(id, expanded, panelRole, children, clsPrefix, copyable, {
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        onExit: onExit,
        onExiting: onExiting,
        onExited: onExited
      }) : this.renderBody(children, clsPrefix, copyable), footer && /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-footer"),
        style: footerStyle
      }, footer));
    }
  }]);

  return Panel;
}(React.Component)) || _class);
Panel.propTypes = propTypes;
export default Panel;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-collapse/src/Panel.js